"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useButtonStyles = void 0;
var tslib_1 = require("tslib");
var styles_1 = require("@material-ui/core/styles");
var style_1 = require("../../../style");
var containedBaseStyles = function (bgHover, color, backgroundColor) {
    if (color === void 0) { color = 'white'; }
    if (backgroundColor === void 0) { backgroundColor = 'none'; }
    return ({
        color: color,
        height: 40,
        backgroundColor: backgroundColor,
        fontSize: 16,
        paddingLeft: 16,
        paddingTop: 10,
        paddingBottom: 10,
        paddingRight: 16,
        borderRadius: 4,
        lineHeight: 0,
        '&:hover': {
            backgroundColor: bgHover,
        },
    });
};
exports.useButtonStyles = styles_1.makeStyles(function () { return ({
    root: {
        textTransform: 'none',
    },
    small: { minWidth: 48 },
    medium: { minWidth: 48 },
    fullWidth: { minWidth: '100%' },
    span: {
        textAlign: 'center',
        height: 10,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
    },
    containedPrimary: tslib_1.__assign({}, containedBaseStyles(style_1.darkGreen, 'white', style_1.mediumGreen)),
    containedSecondary: tslib_1.__assign({}, containedBaseStyles(style_1.darkMediumBlue, 'white', style_1.darkBlue)),
    containedTertiary: tslib_1.__assign({}, containedBaseStyles(style_1.lightBlue, 'white', style_1.mediumLightBlue)),
    containedWarning: tslib_1.__assign({}, containedBaseStyles(style_1.lightYellow, 'white', style_1.mediumYellow)),
    containedError: tslib_1.__assign({}, containedBaseStyles(style_1.lightRed, 'white', style_1.mediumRed)),
    textPrimary: tslib_1.__assign({}, containedBaseStyles(style_1.darkGreen, style_1.mediumGreen)),
    textSecondary: tslib_1.__assign({}, containedBaseStyles(style_1.lightBlue, style_1.darkBlue)),
    textTertiary: tslib_1.__assign({}, containedBaseStyles(style_1.lightBlue, style_1.mediumLightBlue)),
    containedSizeSmall: {
        fontSize: 14,
        height: 32,
    },
    textSizeSmall: {
        fontSize: 14,
        height: 32,
    },
    disabledContainedPrimary: {
        opacity: '0.4',
        backgroundColor: style_1.mediumGreen + " !important",
        color: 'white !important',
    },
    disabledContainedSecondary: {
        opacity: '0.4',
        backgroundColor: style_1.darkBlue + " !important",
        color: 'white !important',
    },
    disabledContainedTertiary: {
        opacity: '0.4',
        backgroundColor: style_1.mediumLightBlue + " !important",
        color: 'white !important',
    },
    disabledTextPrimary: {
        opacity: '0.4',
        color: style_1.mediumGreen + " !important",
    },
    disabledTextSecondary: {
        opacity: '0.4',
        color: style_1.darkBlue + " !important",
    },
    disabledTextTertiary: {
        opacity: '0.4',
        color: style_1.mediumLightBlue + " !important",
    },
}); });
